// Central Pinata / IPFS gateway helper
export const PINATA_GATEWAY = 'https://turquoise-many-mouse-901.mypinata.cloud/ipfs/';
export const ipfsUrl = (cid) => (cid ? `${PINATA_GATEWAY}${cid}` : '');

export default { PINATA_GATEWAY, ipfsUrl };
